import React from "react"
import { Grid, Typography, CardMedia } from "@mui/material"
import { size, COLORS } from "../../utils"
import { DATA } from '../ResearchAssistance/Data'
import ArrowRightIcon from '../../assets/icons/arrowright'
import styles from "./ResearchAssistance.module.css"
import { useNavigate } from "react-router-dom"

export default function ResearchAssistance() {
    const navigate = useNavigate()

    return (
        <Grid item container flexWrap={'nowrap'} direction={'column'} alignItems={'center'}
            justifyContent={'center'} rowGap={size({ p: 2, h: true })}
            m={`${size({ p: 1, h: true })} 0px`} mt='6rem' className={styles.container}
        >
            <Grid item>
                <Typography className={styles['research-text']}
                    sx={{
                        fontFamily: 'Archia',
                        fontSize: size({ p: 2.2 }),
                        fontWeight: 600,
                        textAlign: 'center',
                        color: `${COLORS.C2}`,
                        padding: `0px ${size({ p: 20 })}`
                    }}
                >
                    End-to-End Research Support from Topic Selection to Journal Publication
                </Typography>
            </Grid>
            <Grid item container flexWrap={'wrap'} justifyContent={'space-between'}
    width={size({ p: 85 })} className={styles['card-container']} rowGap={size({ p: 3, h: true })}>
    {
        Object.keys(DATA).map((k) => (
            <Grid item container direction="column"
                rowGap={size({ p: 0.5, h: true })}
                className={styles['card-item']}
                sx={{
                    width: { xs: '100%', sm: '48%', md: '30%' },
                    padding: `${size({ p: 3, h: true })} ${size({ p: 4 })}`,
                }}
            >
                {/* Top Section: Icon + Title */}
                <Grid item container direction="column" rowGap={size({ p: 1, h: true })}>
                    <Grid item>
                        <CardMedia
                            component={'img'}
                            image={DATA[k].icon}
                            sx={{
                                width: size({ p: 3 }),
                                height: size({ p: 3 }),
                            }}
                            className={styles['card-top-icon']}
                        />
                    </Grid>
                    <Grid item>
                        <Typography sx={{
                            fontFamily: 'Archia',
                            fontSize: size({ p: 1.1 }),
                            fontWeight: 500,
                            color: COLORS.C1
                        }} className={styles['card-title']}>
                            {k}
                        </Typography>
                    </Grid>
                </Grid>

                {/* Description */}
                <Grid item>
                    <Typography sx={{
                        fontFamily: 'Archia',
                        fontSize: size({ p: 0.9 }),
                        fontWeight: 400,
                        color: COLORS.C1 + 'A0',
                        height: size({ p: 14, h: true })
                    }} className={styles['card-desc']}>
                        {DATA[k].short_desc.split(" ").slice(0, 25).join(" ") + '...'}
                    </Typography>
                </Grid>

                {/* Learn More Link */}
                <Grid item container flexWrap={'nowrap'} columnGap={size({ p: 0.4 })}
                    justifyContent={"flex-end"} sx={{
                        cursor: 'pointer'
                    }} className={styles['card-learn-container']}>
                    <Grid item>
                        <Typography sx={{
                            fontFamily: 'Archia',
                            fontSize: size({ p: 0.8 }),
                            color: COLORS.C1,
                            fontWeight: 600,
                        }} className={styles['card-learn-more']} onClick={()=> navigate('/research_assistance')}>
                            Learn More
                        </Typography>
                    </Grid>
                    <Grid item mt={size({ p: 0.3, h: true })} className={styles['card-icon']}>
                        <ArrowRightIcon
                            width={size({ p: 1 })}
                            height={size({ p: 1 })}
                            fill={COLORS.C1}
                            className={styles['card-icon-1']}
                        />
                    </Grid>
                </Grid>
            </Grid>
        ))
    }
</Grid>

        </Grid >
    )
}